import { render, staticRenderFns } from "./AppAlertBulk.vue?vue&type=template&id=081f9e91&"
import script from "./AppAlertBulk.vue?vue&type=script&lang=js&"
export * from "./AppAlertBulk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports